import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

const ThemeContext = createContext();

export const defaultTheme = {
  primary: '#0f3033',
  accent1: '#ed116c',
  accent2: '#f5ed21',
  accent3: '#3a419a',
  accent4: '#38c6f1',
  logo: null,
  favicon: null,
  youtubeUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  siteName: 'Nexia Digital',
  tagline: 'Agence Communication & Digital',
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(defaultTheme);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, 'settings', 'theme');
    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setTheme({ ...defaultTheme, ...snap.data() });
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--primary', theme.primary);
    root.style.setProperty('--accent1', theme.accent1);
    root.style.setProperty('--accent2', theme.accent2);
    root.style.setProperty('--accent3', theme.accent3);
    root.style.setProperty('--accent4', theme.accent4);
  }, [theme]);

  const updateTheme = async (updates) => {
    const ref = doc(db, 'settings', 'theme');
    await setDoc(ref, { ...theme, ...updates }, { merge: true });
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme, loading }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
